/**
 * Fade element in/out on page scroll
 */
;
(function( $ ) {
  'use strict';

  $.fn.fadeInOut = function() {
    var opacity;
    var element      = this;
    var scrollTop    = $(window).scrollTop();
    var windowHeight = $(window).height();
    var halfView     = windowHeight / 4;

    function setOpacity(elem) {
      var height = elem.height();
      var offset = elem.offset().top;
      var type   = elem.data('fade').length ? elem.data('fade') : 'in';
      var scrollPoint = offset - halfView;

      if (type == 'in') {
        if ($(window).width() <= siteSettings.breakpoints.fluid) {
          offset = offset - windowHeight;
        }

        opacity = (((scrollTop + windowHeight) - (offset - halfView)) / 1000);
      }
      else {
        if (scrollTop > 0) {
          opacity = (offset + height - scrollTop) / windowHeight;
        }
        else {
          opacity = 1;
        }
      }

      if (opacity >= 1) {
        opacity = 1;
      }
      else if (opacity <= 0) {
        opacity = 0;
      }

      elem.css('opacity', opacity);
    }

    $(window).on('load', function() {
      element.each(function() {
        setOpacity($(this));
      });
    }).on('scroll', function(){
      scrollTop  = $(window).scrollTop();

      element.each(function() {
        setOpacity($(this));
      });
    });
  };
})(jQuery);
